import { Grid } from "@mui/material";
import { useFormikContext } from "formik";
import { DateInput } from "../../../components";
import useLocales from "../../../hooks/useLocales";
import { customerKindEnum } from "../../../utils";

const CustomerDateInput = () => {
  const { translate } = useLocales();
  const formik: any = useFormikContext();
  const { customerKindId }: any = formik.values;

  if (Number(customerKindId) === customerKindEnum.indivual) {
    return (
      <Grid item md={6} lg={6} xs={12} sm={12}>
        <DateInput
          name="dateOfBirth"
          label={translate("dateOfBirth")}
          disabled={formik.values.isExistCustomer}
        />
      </Grid>
    );
  }

  return null;
};

export default CustomerDateInput;
